<template>
  <div class="fee-container">
    <!-- 查询条件区域 -->
    <el-card class="ibox margin-top-sm">
      <div slot="header" class="clearfix flex justify-between">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" class="text-left">
        <!-- 费用类别改为文本框 -->
        <el-form-item label="费用类别">
          <el-input
            placeholder="请输入费用类别"
            size="small"
            v-model="feeInfo.conditions.feeType"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="费用明细">
          <el-input
            placeholder="请输入费用明细"
            size="small"
            v-model="feeInfo.conditions.feeDetail"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="支付时间">
          <el-date-picker
            v-model="feeInfo.conditions.payTimeRange"
            type="datetimerange"
            size="small"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="queryFeeMethod">
            <i class="el-icon-search"></i>查询
          </el-button>
          <el-button type="info" size="small" @click="resetFeeInfo">
            <i class="el-icon-refresh"></i>重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="bg-white padding-sm text-left">
      <!-- 新增按钮 -->
      <el-button type="primary" size="small" @click="openAddFeeModal">
        <i class="el-icon-plus"></i>新增费用
      </el-button>
      <!-- 导入按钮 -->
      <el-button
        type="primary"
        size="small"
        class="margin-left-sm"
        @click="openImportModal"
      >
        <i class="el-icon-upload2"></i>导入费用
      </el-button>
      <!-- 导出按钮 -->
      <el-button
        type="success"
        size="small"
        class="margin-left-sm"
        @click="handleExport"
      >
        <i class="el-icon-download"></i>导出费用
      </el-button>
    </div>

    <!-- 数据列表区域 -->
    <el-card class="margin-top-sm">
      <el-table
        :data="feeInfo.fees"
        style="width: 100%"
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="feeType"
          label="费用类别"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div class="hc-td">{{ scope.row.feeType || "-" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="feeDetail"
          label="费用明细"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <div class="hc-td">{{ scope.row.feeDetail || "-" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="feeAmount"
          label="费用金额"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div class="hc-td">¥{{ scope.row.feeAmount || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="payTime"
          label="支付时间"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <div class="hc-td">{{ scope.row.payTime || "-" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
          <template slot-scope="scope">
            <div class="hc-td">{{ scope.row.remark || "-" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                type="primary"
                @click="openEditFeeModal(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                style="margin-left: 10px"
                size="mini"
                type="danger"
                @click="openDelFeeModal(scope.row)"
              >
                删除
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row class="margin-top">
        <el-col :span="12" class="float-right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="feeInfo.currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="DEFAULT_ROW"
            layout="total, sizes, prev, pager, next, jumper"
            :total="feeInfo.total"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-card>

    <!-- 统一弹窗组件命名，修复ref关联 -->
    <add-fund-payment ref="addFee" @handleRefreshFee="handleRefreshFee" />
    <edit-fund-payment ref="editFee" @handleRefreshFee="handleRefreshFee" />
    <delete-fund-payment ref="deleteFee" @handleRefreshFee="handleRefreshFee" />
    <import-fund-payment ref="importFee" @handleRefreshFee="handleRefreshFee" />
  </div>
</template>

<script>
import { queryFundPayments, exportData } from "@/api/fee/fundPaymentApi";
import AddFundPayment from "@/components/fee/addFundPayment";
import EditFundPayment from "@/components/fee/editFundPayment";
import DeleteFundPayment from "@/components/fee/deleteFundPayment";
import ImportFundPayment from "@/components/fee/importFundPayment";

const DEFAULT_PAGE = 1;
const DEFAULT_ROW = 10;

export default {
  name: "FeeList",
  components: {
    AddFundPayment,
    EditFundPayment,
    DeleteFundPayment,
    ImportFundPayment,
  },
  data() {
    return {
      DEFAULT_PAGE,
      DEFAULT_ROW,
      selectedFee: null,
      feeInfo: {
        fees: [],
        total: 0,
        // 移除下拉选项数据（费用类别改为文本框）
        conditions: {
          feeType: "",
          feeDetail: "",
          payTimeRange: [],
        },
        currentPage: DEFAULT_PAGE,
      },
    };
  },
  mounted() {
    // 页面加载默认查询列表
    this.listFee(DEFAULT_PAGE, DEFAULT_ROW);
  },
  methods: {
    async listFee(page, row) {
      this.feeInfo.conditions.page = page;
      this.feeInfo.conditions.row = row;
      // 补充小区ID（需确保getCommunityId方法已定义）
      this.feeInfo.conditions.communityId = this.getCommunityId
        ? this.getCommunityId()
        : "";

      const params = { ...this.feeInfo.conditions };
      // 处理时间范围参数
      if (params.payTimeRange && params.payTimeRange.length === 2) {
        params.startPayTime = params.payTimeRange[0];
        params.endPayTime = params.payTimeRange[1];
      }
      delete params.payTimeRange;

      try {
        const res = await queryFundPayments(params);
        this.feeInfo.total = res.total || 0;
        this.feeInfo.fees = res.data || [];
      } catch (error) {
        console.error("获取费用列表失败:", error);
        this.$message.error("获取费用列表失败");
      }
    },

    // 刷新列表
    handleRefreshFee() {
      this.listFee(this.feeInfo.currentPage, this.DEFAULT_ROW);
    },

    // 表格选择事件
    handleSelectionChange(selection) {
      this.selectedFee = selection.length > 0 ? selection[0] : null;
    },

    // 查询按钮触发
    queryFeeMethod() {
      this.feeInfo.currentPage = DEFAULT_PAGE; // 查询时重置页码
      this.listFee(DEFAULT_PAGE, DEFAULT_ROW);
    },

    // 重置查询条件
    resetFeeInfo() {
      this.feeInfo.conditions = {
        feeType: "",
        feeDetail: "",
        payTimeRange: [],
      };
      this.feeInfo.currentPage = DEFAULT_PAGE;
      this.listFee(DEFAULT_PAGE, DEFAULT_ROW);
    },

    // 打开新增弹窗
    openAddFeeModal() {
      this.$refs.addFee.open();
    },

    // 行内编辑按钮
    openEditFeeModal(fee) {
      this.$refs.editFee.open(fee);
    },

    // 行内删除按钮
    openDelFeeModal(fee) {
      this.$refs.deleteFee.open(fee);
    },

    // 打开导入弹窗
    openImportModal() {
      this.$refs.importFee.open();
    },

    // 导出费用数据（对齐示例逻辑重构）
    async handleExport() {
      try {
        // 1. 获取园区ID（兼容条件中的ID和全局ID）
        const useCommunityId =
          this.feeInfo.conditions.communityId ||
          (this.getCommunityId ? this.getCommunityId() : "");

        // 2. 构建导出参数（对齐示例结构）
        const params = {
          ...this.feeInfo.conditions,
          pagePath: "fundPaymentList", // 费用列表页面标识（与后端约定）
          communityId: useCommunityId,
          // 移除分页参数，导出全部数据
          page: undefined,
          row: undefined,
        };

        // 3. 处理时间范围参数
        if (params.payTimeRange && params.payTimeRange.length === 2) {
          params.startPayTime = params.payTimeRange[0];
          params.endPayTime = params.payTimeRange[1];
        }
        delete params.payTimeRange; // 删除前端专用参数

        // 4. 调用导出接口（对齐示例的调用方式）
        await exportData(params);

        // 5. 提示并跳转下载中心
        this.$message.success("导出成功，请到下载中心查看");
        this.$router.push("/pages/property/downloadTempFile?tab=下载中心");
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败，请稍后重试");
      }
    },

    // 每页条数改变
    handleSizeChange(val) {
      this.listFee(this.feeInfo.currentPage, val);
    },

    // 页码改变
    handleCurrentChange(val) {
      this.feeInfo.currentPage = val;
      this.listFee(val, this.DEFAULT_ROW);
    },
  },
};
</script>

<style scoped>
.fee-container {
  padding: 15px;
  height: calc(100vh - 120px);
  overflow: auto; /* 改为auto，避免内容溢出无法滚动 */
}

.bg-white {
  background-color: #fff;
}

.padding-sm {
  padding: 10px;
}

.margin-left-sm {
  margin-left: 10px;
}

.margin-top-sm {
  margin-top: 15px;
}

.ibox {
  margin-bottom: 15px;
}

.hc-td {
  padding: 5px;
  text-align: center;
}

.float-right {
  float: right;
}

.text-center {
  text-align: center;
}

/* 修复分页样式 */
.margin-top {
  margin-top: 10px;
}
</style>
